function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10 5a1 1 0 100 2h6a1 1 0 100-2h-6z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 8A2.5 2.5 0 001 10.5v13A2.5 2.5 0 003.5 26h18a2.5 2.5 0 002.5-2.5v-1.273l2.694 2.394a1.5 1.5 0 00.996.379H30a1 1 0 001-1V10a1 1 0 00-1-1h-2.31a1.5 1.5 0 00-.996.379L24 11.773V10.5A2.5 2.5 0 0021.5 8h-18zM3 10.5a.5.5 0 01.5-.5h18a.5.5 0 01.5.5V14a1 1 0 001.664.747L27.88 11H29v12h-1.12l-4.216-3.747A1 1 0 0022 20v3.5a.5.5 0 01-.5.5h-18a.5.5 0 01-.5-.5v-13z",
  fill: "currentColor"
})));